import { style } from '@vanilla-extract/css';

import { BUTTON_SHADOW, card, FOCUS_OUTLINE, tokens } from './tipJarTheme.css';

export const share = style([card, { gap: '16px' }]);

export const heading = style({
  margin: 0,
  fontFamily: tokens.headerFont,
  fontSize: '18px',
  fontWeight: 600,
  lineHeight: '24px',
});

export const body = style({
  margin: '-10px 0 0',
  fontSize: '14px',
  lineHeight: '20px',
  color: tokens.muted,
});

export const actions = style({
  display: 'flex',
  flexWrap: 'wrap',
  gap: '8px',
});

export const action = style({
  display: 'inline-flex',
  flex: '1 1 140px',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '8px',
  minHeight: '44px',
  boxSizing: 'border-box',
  padding: '0 18px',
  border: '1px solid transparent',
  borderRadius: tokens.controlRadius,
  background: tokens.primary,
  color: tokens.onPrimary,
  fontFamily: tokens.buttonFont,
  fontSize: '15px',
  fontWeight: 600,
  lineHeight: '20px',
  cursor: 'pointer',
  boxShadow: BUTTON_SHADOW,
  transition: 'opacity 150ms ease, background-color 150ms ease',
  selectors: {
    '&:focus-visible': FOCUS_OUTLINE,
  },
});

export const secondaryAction = style({
  borderColor: tokens.line,
  background: tokens.surface,
  color: tokens.ink,
  boxShadow: '0 2px 6px rgb(0 0 0 / 0.04), 0 4px 8px rgb(0 0 0 / 0.06)',
  selectors: {
    '&:hover': { background: tokens.tint },
  },
});

export const primaryAction = style({
  selectors: {
    '&:hover': { opacity: 0.9 },
  },
});

export const platforms = style({
  display: 'flex',
  flexWrap: 'wrap',
  gap: '8px',
});

export const platform = style({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '44px',
  height: '44px',
  boxSizing: 'border-box',
  padding: 0,
  background: tokens.surface,
  color: tokens.ink,
  boxShadow: '0 2px 6px rgb(0 0 0 / 0.04)',
  transition: 'background-color 150ms ease',
  selectors: {
    '&:hover': { background: tokens.tint },
    '&:focus-visible': FOCUS_OUTLINE,
  },
});
